
<div class="container">


  <h2 class="content-heading">
    <button class="btn btn-sm btn-outline-secondary float-right" (click)="add()">
      <i class="fa fa-plus mr-5"></i>Add Lectionary Source
    </button>
      Lectionary Source
</h2>
 


          <div class="blockX">



            <div class="block-contentX">



  <div class="table-responsive table yearDataTable" xclass="table table-striped table-vcenter table-sm">

      <div class="xrow header gridRow row">
          <div class="col-md-4">Name</div>
          <div class="col-md-6">Description</div>
          <div class="col-md-1 text-right">Is Active</div>
          <div class="col-md-1 text-right">Actions</div>
      </div>


    <div id="scrollableTable">
        <div class="">
          <div *ngFor="let obj of entities" class="dateRow gridRow row">

            <div class="col-md-4">{{obj.Name}}</div>
            <div class="col-md-6">{{obj.Description}}</div>
            <div class="col-md-1 text-right">{{obj.IsActive}}</div>
            <div class="col-md-1 text-right">
                <div class="btn-group">
                    <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit" (click)="edit(obj)">
                        <i class="fa fa-pencil"></i>
                    </button>
                    <!-- <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Delete" (click)="delete(obj)">
                        <i class="fa fa-times"></i>
                    </button> -->
                  </div>
                </div>
            </div>
          </div>
        </div>

    </div>



            </div>



            <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>
      </div>

    </div>


